export default "__VITE_PUBLIC_ASSET__48acdfb6__"